import Link from "next/link"
import { getPlayerPageUrl } from "../../../../utils/urls"
import { LocalizedMatchTeamPlayer, LocalizedMatchTeamPlayers } from "../../../../types/matchTeamPlayer"
import { LocalizedTeam } from "../../../../types/team"
import { LocalizedMatch } from "../../../../types/match"
import * as ImageConstants from "../../../../constants/images"
import { sortBy } from "lodash"
import Image from "next/image"
import style from "./style.module.scss"
import { NewTitleBanner } from "@components/Banners/NewTitleBanner"
import { Row, Col } from "react-bootstrap"

type awayOrHomeType = "home" | "away"

function TeamLineupStarter({
  awayOrHome,
  team,
  matchTeamPlayers,
}: {
  awayOrHome: awayOrHomeType
  team: LocalizedTeam
  matchTeamPlayers: LocalizedMatchTeamPlayer[]
}) {
  return (
    <div className={style.starter}>
      <Row className={style.teamInfo}>
        <Col xs={12} sm={12} md={2} lg={2} xl={2} className={style.teamImg}>
          <Image
            src={team.image?.path || ImageConstants.TEAM_MISSING_IMAGE_PATH}
            alt={team.name}
            title={team.name}
            layout={"intrinsic"}
            width={50}
            height={50}
          />
        </Col>
        <Col xs={12} sm={12} md={10} lg={10} xl={10} className={style.teamName}>
          <span>{team.name}</span>
        </Col>
      </Row>
      {sortBy(matchTeamPlayers, ["roleId"]).map((matchTeamPlayer, index) => {
        const player = matchTeamPlayer.player!

        const playerUrl = getPlayerPageUrl(player.calciocomSlug!)

        let role = ""
        let roleClassName = ""
        switch (matchTeamPlayer.role?.id) {
          case 1:
            roleClassName = "goalkeeper"
            role = "P"
            break
          case 2:
            roleClassName = "defender"
            role = "D"
            break
          case 3:
            roleClassName = "midfielder"
            role = "C"
            break
          case 4:
            roleClassName = "forward"
            role = "A"
            break
          default:
            break
        }

        return (
          <Row key={index} className={style.eventRow}>
            <Col xs={2} sm={2} md={2} lg={2} xl={2} className={style.playerShirtNUmber}>
              {matchTeamPlayer.jerseyNumber || ""}
            </Col>
            <Col xs={8} sm={8} md={8} lg={8} xl={8} className={style.player}>
              <Link href={playerUrl}>
                <a title={player.name}>{player.name}</a>
              </Link>
            </Col>
            <Col xs={2} sm={2} md={2} lg={2} xl={2} className={style.playerRole}>
              {role}
            </Col>
          </Row>
        )
      })}
    </div>
    // <div className={"hs-starter " + awayOrHome}>
    //   <h3>
    //     <div className="team-image">
    //       <Image
    //         src={team.image?.path || ImageConstants.TEAM_MISSING_IMAGE_PATH}
    //         alt={team.name}
    //         title={team.name}
    //         layout={"intrinsic"}
    //         width={30}
    //         height={30}
    //       />
    //     </div>
    //     <div className={"currentTeam-shortname currentTeam-shortname-" + awayOrHome}>{team.name}</div>
    //   </h3>
    //   <div className="module-events">
    //     <>
    //       {sortBy(matchTeamPlayers, ["roleId"]).map((matchTeamPlayer, index) => {
    //         const player = matchTeamPlayer.player!

    //         const playerUrl = getPlayerPageUrl(player.calciocomSlug!)

    //         let role = ""
    //         let roleClassName = ""
    //         switch (matchTeamPlayer.role?.id) {
    //           case 1:
    //             roleClassName = "goalkeeper"
    //             role = "P"
    //             break
    //           case 2:
    //             roleClassName = "defender"
    //             role = "D"
    //             break
    //           case 3:
    //             roleClassName = "midfielder"
    //             role = "C"
    //             break
    //           case 4:
    //             roleClassName = "forward"
    //             role = "A"
    //             break
    //           default:
    //             break
    //         }

    //         return (
    //           <div key={index} className={"event playing lineup " + awayOrHome}>
    //             <div className="team_person-shirtnumber">{matchTeamPlayer.jerseyNumber || ""}</div>
    //             <div className="person-name person-name-">
    //               <Link href={playerUrl}>
    //                 <a title={player.name}>{player.name}</a>
    //               </Link>
    //             </div>
    //             {matchTeamPlayer.subOut && (
    //               <>
    //                 <div className={"sub-in match_event substitute-out"}></div>
    //                 <div className={"team_person-sub"}>{`${matchTeamPlayer.subOut}′`}</div>
    //               </>
    //             )}
    //             <div className={"team_person-role team_person-role-" + roleClassName}>{role}</div>
    //           </div>
    //         )
    //       })}
    //     </>
    //   </div>
    // </div>
  )
}

function TeamLineupBench({
  awayOrHome,
  matchTeamPlayers,
}: {
  awayOrHome: awayOrHomeType
  matchTeamPlayers: LocalizedMatchTeamPlayer[]
}) {
  if (matchTeamPlayers.length > 0) {
    return (
      <div className={style.bench}>
        <Row className={style.title}>
          <Col>
            <h3>Riserve</h3>
          </Col>
        </Row>
        {matchTeamPlayers.map((matchTeamPlayer, index) => {
          const player = matchTeamPlayer.player!

          const playerUrl = getPlayerPageUrl(player.calciocomSlug!)

          return (
            <Row key={index} className={style.eventRow}>
              <Col xs={2} sm={2} md={2} lg={2} xl={2} className={style.playerShirtNUmber}>
                {matchTeamPlayer.jerseyNumber || ""}
              </Col>
              <Col xs={8} sm={8} md={8} lg={8} xl={8} className={style.player}>
                <Link href={playerUrl}>
                  <a title={player.name}>{player.name}</a>
                </Link>
              </Col>
              <Col xs={2} sm={2} md={2} lg={2} xl={2} className={style.playerRole}>
                {matchTeamPlayer.subIn && `${matchTeamPlayer.subIn}′`}
              </Col>
            </Row>
          )
        })}
      </div>
      // <div className={"hs-bench " + awayOrHome}>
      //   <h2 className="hs-block-header">Riserve</h2>
      //   <div className="module-events">
      //     <div>
      //       {matchTeamPlayers.map((matchTeamPlayer, index) => {
      //         const player = matchTeamPlayer.player!

      //         const playerUrl = getPlayerPageUrl(player.calciocomSlug!)

      //         return (
      //           <div key={index} className={"event playing bench " + awayOrHome}>
      //             <div className="team_person-shirtnumber">{matchTeamPlayer.jerseyNumber || ""}</div>
      //             <div className="person-name person-name-">
      //               <Link href={playerUrl}>
      //                 <a title={player.name}>{player.name}</a>
      //               </Link>
      //             </div>
      //             {matchTeamPlayer.subIn && (
      //               <>
      //                 <div className={"sub-in match_event substitute-in"}></div>
      //                 <div className={"team_person-sub"}>{`${matchTeamPlayer.subIn}′`}</div>
      //               </>
      //             )}
      //           </div>
      //         )
      //       })}
      //     </div>
      //   </div>
      // </div>
    )
  } else {
    return <></>
  }
}

export function MatchTeamPlayers({
  match,
  matchTeamPlayers,
}: {
  match: LocalizedMatch
  matchTeamPlayers: LocalizedMatchTeamPlayers
}) {
  const { homeTeam, awayTeam } = match
  const { homeTeamPlayers, awayTeamPlayers } = matchTeamPlayers

  return (
    <div className={style.matchTeamPlayersMainContainer}>
      <NewTitleBanner title={`Formazioni ${homeTeam?.name} - ${awayTeam?.name}`} />
      {homeTeam && awayTeam && (
        <Row className={style.container}>
          <Col xs={12} sm={12} md={6} lg={6} xl={6} className={style.left}>
            <TeamLineupStarter
              awayOrHome="home"
              team={homeTeam}
              matchTeamPlayers={homeTeamPlayers.filter(
                (matchTeamPlayer) => matchTeamPlayer.starter === true || matchTeamPlayer.starter == null,
              )}
            />
            <TeamLineupBench
              awayOrHome="home"
              matchTeamPlayers={homeTeamPlayers.filter((matchTeamPlayer) => matchTeamPlayer.starter === false)}
            />
          </Col>
          <Col xs={12} sm={12} md={6} lg={6} xl={6}>
            <TeamLineupStarter
              awayOrHome="away"
              team={awayTeam}
              matchTeamPlayers={awayTeamPlayers.filter(
                (matchTeamPlayer) => matchTeamPlayer.starter === true || matchTeamPlayer.starter == null,
              )}
            />

            <TeamLineupBench
              awayOrHome="away"
              matchTeamPlayers={awayTeamPlayers.filter((matchTeamPlayer) => matchTeamPlayer.starter === false)}
            />
          </Col>
        </Row>
      )}
    </div>
  )
}
